<template>
    <HeaderContent title="Surat Perintah jalan"/>
    <ActionContent ctaText="SPJ" @action="modal = !modal "/>
    <AdminStatistics title="SPJ Statistics" :data="statistics" />
    <AdminDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>

</template>


<script>
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import AdminDataTable from '@/components/DataTable.vue';
import AdminStatistics from '@/components/StatisticData.vue';
import spj from '@/dummy-data/spj.js';
// import iconLevel from '../../../public/icons/arrow-comparison.svg';
import iconUser from '../../../public/icons/users-alt.svg';
import { ref,} from 'vue';

export default{
    name : 'SPJ',
    components: {
        HeaderContent,
        ActionContent,
        AdminDataTable,
        AdminStatistics
    },
    setup(){
        const modal = ref(false)
        const statistics = ref([
            {
                label: 'Total',
                key: 'On Travel',
                value: 3,
                color: 'info',
                icon: iconUser,
            },
            {
                label: 'Total',
                key: 'Waiting',
                value: 2,
                color: 'info',
                icon: iconUser,
            },
        ]);
        const headers = ref([
            {key : 'id',label: 'ID',sortable: true,},
            {key : 'invoice', label : 'Invoice Number',sortable: true,},
            {key : 'guest', label : 'Guest',sortable: true,},
            {key : 'start_travel', label : 'Start Travel',sortable: true,},
            {key : 'pax', label : 'Pax',sortable: true,},
            {key : 'driver', label : 'Driver/guide',sortable: true,},
            {key: 'action', label: 'Actions',}
        ])
        const customActions = ref([
    
        {
            label: 'Edit',
            variant: 'success',
            icon: 'fas fa-edit',
            action: (item) => {
            console.log('Edit action clicked for:', item);
            // Implement your edit logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
    
    ])
    const data= spj
    return{
        modal,statistics,headers,customActions,data
    }
     
    }
  
}

</script>


